import Coupon from "./Coupon";
import Documentation from "./Documentation";
import Guarantee from "./Guarantee";
import Guidance from "./Guidance";
import Identifier from "./Identifier";
import Entity from "./Entity";
import Management from "./Management";
import Manager from "./Manager";
import Maturity from "./Maturity";
import Ratings from "./Ratings";
import Nominal from "./Nominal";
import Pricing from "./Pricing";
import Settlement from "./Settlement";
class TrancheData {
    coupons;
    documentation;
    guarantee;
    guidance;
    identifiers;
    initialPriceThoughts;
    issuer;
    management;
    managers;
    maturity;
    nominal;
    obligor;
    pricing;
    pricingDate;
    profitRates;
    ratings;
    revisedGuidance;
    settlement;
    tap;
    useOfProceeds;
    constructor(trancheData) {
        this.coupons = trancheData.coupons?.map(c => new Coupon(c));
        this.documentation = trancheData.documentation !== undefined ? new Documentation(trancheData.documentation) : undefined;
        this.guarantee = trancheData.guarantee !== undefined ? new Guarantee(trancheData.guarantee) : undefined;
        this.guidance = trancheData.guidance !== undefined ? new Guidance(trancheData.guidance) : undefined;
        this.identifiers = trancheData.identifiers?.map(i => new Identifier(i));
        this.initialPriceThoughts = trancheData.initialPriceThoughts !== undefined ? new Guidance(trancheData.initialPriceThoughts) : undefined;
        this.issuer = trancheData.issuer !== undefined ? new Entity(trancheData.issuer) : undefined;
        this.management = trancheData.management !== undefined ? new Management(trancheData.management) : undefined;
        this.managers = trancheData.managers?.map(m => new Manager(m));
        this.maturity = trancheData.maturity !== undefined ? new Maturity(trancheData.maturity) : undefined;
        this.nominal = trancheData.nominal !== undefined ? new Nominal(trancheData.nominal) : undefined;
        this.obligor = trancheData.obligor !== undefined ? new Entity(trancheData.obligor) : undefined;
        this.pricing = trancheData.pricing !== undefined ? new Pricing(trancheData.pricing) : undefined;
        this.pricingDate = trancheData.pricingDate;
        this.profitRates = trancheData.profitRates?.map(p => new Coupon(p));
        this.ratings = trancheData.ratings !== undefined ? new Ratings(trancheData.ratings) : undefined;
        this.revisedGuidance = trancheData.revisedGuidance !== undefined ? new Guidance(trancheData.revisedGuidance) : undefined;
        this.settlement = trancheData.settlement !== undefined ? new Settlement(trancheData.settlement) : undefined;
        this.tap = trancheData.tap;
        this.useOfProceeds = trancheData.useOfProceeds;
    }
    toResponse() {
        return {
            coupons: this.coupons,
            documentation: this.documentation,
            guarantee: this.guarantee,
            guidance: this.guidance,
            identifiers: this.identifiers,
            initialPriceThoughts: this.initialPriceThoughts,
            issuer: this.issuer,
            management: this.management,
            managers: this.managers,
            maturity: this.maturity,
            nominal: this.nominal,
            obligor: this.obligor,
            pricing: this.pricing,
            pricingDate: this.pricingDate,
            profitRates: this.profitRates,
            ratings: this.ratings,
            revisedGuidance: this.revisedGuidance,
            settlement: this.settlement !== undefined ? this.settlement.toResponse() : undefined,
            tap: this.tap
        };
    }
    basis() {
        return this.initialPriceThoughts?.basis() ?? this.guidance?.basis() ?? this.revisedGuidance?.basis();
    }
    benchmark() {
        return this.initialPriceThoughts?.benchmark() ?? this.guidance?.benchmark() ?? this.revisedGuidance?.benchmark();
    }
    currency() {
        return this.nominal?.amount?.currency ?? this.nominal?.tapAmount?.currency;
    }
}
export default TrancheData;
